module.exports = __webpack_public_path__ + "img/es.b3c9e7e1.svg";